module.exports = __webpack_public_path__ + "static/media/Pattern_2.ec9d8654.png";